import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getFiscalFullName = (
  fiscalType: string,
  countryRegistration: string
) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP ? 'Full name IP*' : 'Company name*',
      rus: ft === FiscalType.IP ? 'Полное наименование ИП*' : 'Название компании*',
      kz: ft === FiscalType.IP
        ? 'Толық аты IP*'
        : ft === FiscalType.JSC
        ? 'Толық аты АҚ*'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Толық аты ЖАҚ*'
        : ft === FiscalType.LLP
        ? 'Толық аты ЖШС*'
        : 'Толық аты ЖШС*',
    },
    placeholder: {
      eng: ft === FiscalType.IP
        ? countryRegistration === '398' ? 'IP «Lastochka»' : 'IP «London industrial company»'
        : ft === FiscalType.JSC
        ? countryRegistration === '398' ? 'JSC «Almaty Industrial Company»' : 'JSC «London industrial company»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '398' ? 'PJSC «Almaty Industrial Company»' : 'PJSC «London industrial company»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '398' ? 'CJSC «Almaty Industrial Company»' : 'CJSC «London industrial company»'
        : ft === FiscalType.LLP
        ? countryRegistration === '398' ? 'LLP «Almaty Industrial Company»' : 'LLP «London industrial company»'
        : 'LLC «London industrial company»',
      rus: ft === FiscalType.IP
        ? countryRegistration === '398' ? 'ИП «Ласточка»' : 'ИП «Московская промышленная компания»'
        : ft === FiscalType.JSC
        ? countryRegistration === '398' ? 'АО «Алматинская промышленная компания»' : 'АО «Московская промышленная компания»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '398' ? 'ПАО «Алматинская промышленная компания»' : 'ПАО «Московская промышленная компания»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '398' ? 'ЗАО «Алматинская промышленная компания»' : 'ЗАО «Московская промышленная компания»'
        : ft === FiscalType.LLP && countryRegistration === '398'
        ? 'ТОО «Алматинская промышленная компания»'
        : 'ООО «Московская промышленная компания»',
      kz: ft === FiscalType.IP
        ? countryRegistration === '398' ? 'IP «Martïn»' : 'IP «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.JSC
        ? countryRegistration === '398' ? 'АҚ «Алматы өнеркәсіп кәсіпорны»' : 'АҚ «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '398' ? 'ЖАҚ «Алматы өнеркәсіп кәсіпорны»' : 'ЖАҚ «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '398' ? 'ЖАҚ «Алматы өнеркәсіп кәсіпорны»' : 'ЖАҚ «Мәскеу өнеркәсіптік компаниясы»'
        : ft === FiscalType.LLP
        ? countryRegistration === '398' ? 'ЖШС «Алматы өнеркәсіп кәсіпорны»' : '(ЖШС «Мәскеу өнеркәсіптік компаниясы»'
        : 'ЖШС «Мәскеу өнеркәсіптік компаниясы»',
    },
    invalidText: {
      eng: ft === FiscalType.IP ? 'Enter the name of the IP correctly' : 'Enter the name of the LLP correctly',
      rus: ft === FiscalType.IP ? 'Введите наименование ИП корректно' : 'Введите наименование ТОО корректно',
      kz: ft === FiscalType.IP ? 'Атауын дұрыс енгізіңіз' : 'ЖШС атауын дұрыс енгізіңіз',
    },
  }
}
